export default __webpack_public_path__ + "static/media/extend.3f2aa3f4.png";